export default {
  hidden_rates:
    'Joillakin maksutavoilla on myös oma hintansa, jonka alustan tuki on määrittänyt. Ne korvaavat tämän hinnan.',
  title: 'Käsittelymaksut',
  subtitle: 'Käsittelymaksu, joka veloitetaan yritykseltä {{company}} verkkomaksuista Stripen maksujen kattamiseksi.',
  card_title: 'Käsittelymaksu',
  status: {
    inherited_tag: 'Kumppanin oletus',
    inherited: 'Tältä ravintolalta veloitetaan oletuksena asettamasi käsittelymaksu.',
    custom_tag: 'Mukautettu',
    custom: 'Tällä ravintolalla on oma käsittelymaksu, joka korvaa oletusarvosi.',
    none_title: 'Käsittelymaksua ei ole asetettu',
    none: 'Millään tällä ravintolalla tai oletusasetuksellasi ei ole hintaa. Jos et ole vahvistanut 0 %:n marginaalia kumppanin käsittelymaksusivulla, ravintola ei voi aloittaa toimintaansa eikä ottaa vastaan verkkomaksuja. Vahvistuksen jälkeen sitä ei veloiteta lainkaan ja maksat Stripen maksut sen maksuista.',
  },
  buttons: {
    set_custom: 'Aseta mukautettu maksu',
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
    reset_to_default: 'Palauta oletukseksi',
  },
  toasts: {
    load_error: 'Käsittelymaksua ei voitu ladata.',
    failed_to_save_changes: 'Käsittelymaksua ei voitu tallentaa.',
    changes_got_saved: 'Käsittelymaksu tallennettu',
    reset_to_default: 'Tämä ravintola käyttää nyt oletuskäsittelymaksuasi.',
  },
};
